export function checkPassword(text) {
  return text.length >= 6 ? false : true;
}
